import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './App.css';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from './images/icons/icon-position-map.png';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const navItems = [
    'Home',
    'Menu',
    'Contact',
    'About',
    'Book a Table'
  ];

  return (
    <nav className="navbar">
      <div className="nav-container">
        <div className="nav-logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="nav-menu">
          {navItems.map((item, index) => (
            <Link
              key={index}
              to={
                item === 'Home'
                  ? '/'
                  : `/${item.toLowerCase().replaceAll(' ', '-')}`
              }
              className="nav-link"
            >
              {item}
            </Link>
          ))}
        </div>

        <div className="nav-actions">
          <Link to="/signin" className="sign-in-btn">
            Sign In
          </Link>
        </div>

        <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
        {navItems.map((item, index) => (
          <Link
            key={index}
            to={
              item === 'Home'
                ? '/'
                : `/${item.toLowerCase().replaceAll(' ', '-')}`
            }
            className="mobile-nav-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            {item}
          </Link>
        ))}
        <Link
          to="/signin"
          className="mobile-sign-in-btn"
          onClick={() => setIsMobileMenuOpen(false)}
        >
          Sign In
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
